import { render } from "./si-icon.component.vue?vue&type=template&id=785455cb&ts=true"
import script from "./si-icon.component.vue?vue&type=script&lang=ts"
export * from "./si-icon.component.vue?vue&type=script&lang=ts"

import "./si-icon.component.vue?vue&type=style&index=0&id=785455cb&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__